import { INITIAL_STATE, setRecentTags } from '../core'
import {
    RECEIVE_RECENT_TAGS,
} from '../action_creators'

function recentTags(state=INITIAL_STATE.recentTags, action) {
    switch (action.type) {
        case RECEIVE_RECENT_TAGS:
            return setRecentTags(state, action.recentTags)
        default:
            return state
    }
}

export default recentTags



// WEBPACK FOOTER //
// ./src/redux/reducers/recent_tags_reducer.js